import { render } from "./LinkButton.vue?vue&type=template&id=0992f1e5&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import "./LinkButton.vue?vue&type=style&index=0&id=0992f1e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0992f1e5"]])

export default __exports__